import React from 'react'
import { Component } from 'react'
import Constantes from '../php/Constantes';
import { Box, CircularProgress, Container, Grid, Modal, Paper, styled, Table, TableBody, TableCell, tableCellClasses, TableContainer, TableHead, TableRow } from '@mui/material';
import { Redirect } from 'react-router-dom';


const StyledTableCell = styled (TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: theme.palette.common.black,
      color: theme.palette.common.white,
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 14,
    },
}));
  
const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
        backgroundColor: theme.palette.action.hover,
    },
    // hide last border
    '&:last-child td, &:last-child th': {
        border: 0,
    },
}));


class ActividadesPendientes extends Component {
    constructor(props){
        super(props);
        this.state = {
            calificaciones: [],
            informes: [],
            carneSalud: [],
            hayInformes: false,
            hayCalificaciones: false,
            hayCarneSalud: false,
            loading: true,
        }
    }

    async componentDidMount(){
        const cargaUtil = JSON.stringify([sessionStorage.lugar,sessionStorage.lugarCentral, sessionStorage.tipoUsuario, sessionStorage.numeroFuncionarioAsociado, 2023]);
        const respuesta = await fetch(`${Constantes.RUTA_API}/obtener_actividades.php`,{
            method: 'POST',
            body: cargaUtil,
        })
        const datos = await respuesta.json();
        this.setState({
            loading: false,
        })
        if(datos[3]){
            this.setState({
                calificaciones: datos[0],
                hayCalificaciones: true,
            })
        }
        if(datos[4]){
            this.setState({
                informes: datos[1],
                hayInformes: true,
            })
        }
        if(datos[5]){
            this.setState({
                carneSalud: datos[2],
                hayCarneSalud: true,
            })
        }
    }

    render(){
        return (
            <>
            {sessionStorage.login && sessionStorage.tipoUsuario === '3'
            ?
                <Container>
                    {this.state.hayCalificaciones
                    ?
                        <Container>
                            <h4>Calificaciones Pendientes</h4>
                            <p style={{color: 'red'}}>Fecha limite 10/01/2023</p>
                            <TableContainer style={{width: '80%', marginLeft:'auto', marginRight:'auto'}} component={Paper}>
                                <Table sx={{minWidth: 700}}>
                                    <TableHead>
                                        <TableRow>
                                            <StyledTableCell width={'33%'}>Número Funcionario</StyledTableCell>
                                            <StyledTableCell width={'33%'}>Nombre Funcionario</StyledTableCell>
                                            <StyledTableCell width={'33%'}>Fecha Calificación</StyledTableCell>
                                            <StyledTableCell></StyledTableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                    {this.state.calificaciones.map((cal, index) => (
                                        <StyledTableRow key={index}>
                                            <StyledTableCell>{cal.numeroFuncionario}</StyledTableCell>
                                            <StyledTableCell>{cal.nombreFuncionario}</StyledTableCell>
                                            <StyledTableCell>{cal.fecha}</StyledTableCell>
                                            <StyledTableCell><a href="./Calificaciones">Realizar</a></StyledTableCell>
                                        </StyledTableRow>
                                    ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Container>
                    :
                        null
                    }
                    
                    <br/>
                    {this.state.hayInformes
                    ?
                        <Container>
                            <h4>Informes Pendientes</h4>
                            <TableContainer style={{width: '80%', marginLeft:'auto', marginRight:'auto'}} component={Paper}>
                                <Table sx={{minWidth: 700}}>
                                    <TableHead>
                                        <TableRow>
                                            <StyledTableCell width={'33%'}>Informe</StyledTableCell>
                                            <StyledTableCell width={'33%'}>Número Funcionario</StyledTableCell>
                                            <StyledTableCell width={'33%'}>Nombre Funcionario</StyledTableCell>
                                            <StyledTableCell width={'33%'}>Fecha Solicitado</StyledTableCell>
                                            <StyledTableCell></StyledTableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                    {this.state.informes.map((cal) => (
                                        <StyledTableRow key={cal.idInformes}>
                                            <StyledTableCell>{cal.informe}</StyledTableCell>
                                            <StyledTableCell>{cal.numeroFuncionario}</StyledTableCell>
                                            <StyledTableCell>{cal.nombreFuncionario}</StyledTableCell>
                                            <StyledTableCell>{String(cal.solicitado).substring(8,10) + '/' + String(cal.solicitado).substring(5,7) + '/' + String(cal.solicitado).substring(0,4)}</StyledTableCell>
                                            {sessionStorage.numeroFuncionarioAsociado === cal.numeroFuncionario
                                            ?
                                                <StyledTableCell></StyledTableCell>
                                            :
                                                <StyledTableCell><a href="./Informes-jefes">Realizar</a></StyledTableCell>
                                            }
                                        </StyledTableRow>
                                    ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Container>
                    :
                        null
                    }
                    {this.state.hayCarneSalud
                    ?
                        <Container>
                            <br/>
                            <h4>Carné de Salud Proximos a Vencer</h4>
                            <TableContainer style={{width: '80%', marginLeft:'auto', marginRight:'auto'}} component={Paper}>
                                <Table sx={{minWidth: 700}}>
                                    <TableHead>
                                        <TableRow>
                                            <StyledTableCell width={'33%'}>Número Funcionario</StyledTableCell>
                                            <StyledTableCell width={'33%'}>Nombre Funcionario</StyledTableCell>
                                            <StyledTableCell width={'33%'}>Vencimiento</StyledTableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {this.state.carneSalud.map((car) => (
                                            <StyledTableRow key={car.numeroFuncionario}>
                                                {car.vencido ? <StyledTableCell style={{color: 'red'}}>{car.numeroFuncionario}</StyledTableCell> : <StyledTableCell style={{color: 'blue'}}>{car.numeroFuncionario}</StyledTableCell>}
                                                {car.vencido ? <StyledTableCell style={{color: 'red'}}>{car.nombreFuncionario}</StyledTableCell> : <StyledTableCell style={{color: 'blue'}}>{car.nombreFuncionario}</StyledTableCell>}
                                                {car.vencido ? <StyledTableCell style={{color: 'red'}}>{car.fechaVencimiento}</StyledTableCell> : <StyledTableCell style={{color: 'blue'}}>{car.fechaVencimiento}</StyledTableCell>}
                                            </StyledTableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Container>
                    :
                        null
                    }
                    {this.state.hayCalificaciones === false && this.state.hayInformes === false && this.state.hayCarneSalud === false
                    ?
                        <h3>No tiene actividades pendientes</h3>
                    :
                        null
                    }
                    <br/>
                </Container>
            :
                sessionStorage.login && sessionStorage.tipoUsuario === '4'
                ?
                    <Container>
                        {this.state.loading
                        ?
                            <div style={{placeItems: 'center'}}>
                                <Box sx={{alignItems: 'center'}}>
                                    <CircularProgress/>
                                </Box>
                            </div>
                        :
                            null
                        }
                        {this.state.hayCalificaciones
                        ?
                            <Container>
                                <h4>Calificaciones Pendientes</h4>
                                <TableContainer style={{width: '80%', marginLeft:'auto', marginRight:'auto'}} component={Paper}>
                                    <Table sx={{minWidth: 700}}>
                                        <TableHead>
                                            <TableRow>
                                                <StyledTableCell width={'33%'}>Número Funcionario</StyledTableCell>
                                                <StyledTableCell width={'33%'}>Nombre Funcionario</StyledTableCell>
                                                <StyledTableCell width={'33%'}>Fecha Calificación</StyledTableCell>
                                                {sessionStorage.tipoUsuario !== '4' ? <StyledTableCell></StyledTableCell> : null }
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                        {this.state.calificaciones.map((cal) => (
                                            <StyledTableRow key={cal.idCalificacionesIngreso}>
                                                <StyledTableCell>{cal.numeroFuncionario}</StyledTableCell>
                                                <StyledTableCell>{cal.nombreFuncionario}</StyledTableCell>
                                                <StyledTableCell>{cal.fecha}</StyledTableCell>
                                                {sessionStorage.tipoUsuario !== '4' ? <StyledTableCell><a href=".Calificaciones">Realizar</a></StyledTableCell> : null }
                                            </StyledTableRow>
                                        ))}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </Container>
                        :
                            null
                        }
                        <br/>
                        {this.state.hayInformes
                        ?
                            <Container>
                                <h4>Informes Pendientes</h4>
                                <TableContainer style={{width: '80%', marginLeft:'auto', marginRight:'auto'}} component={Paper}>
                                    <Table sx={{minWidth: 700}}>
                                        <TableHead>
                                            <TableRow>
                                                <StyledTableCell>Informe</StyledTableCell>
                                                <StyledTableCell>Número Funcionario</StyledTableCell>
                                                <StyledTableCell>Nombre Funcionario</StyledTableCell>
                                                <StyledTableCell>Fecha Solicitado</StyledTableCell>
                                                <StyledTableCell></StyledTableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                        {this.state.informes.map((cal) => (
                                            <StyledTableRow key={cal.idInformes}>
                                                <StyledTableCell>{cal.informe}</StyledTableCell>
                                                <StyledTableCell>{cal.numeroFuncionario}</StyledTableCell>
                                                <StyledTableCell>{cal.nombreFuncionario}</StyledTableCell>
                                                <StyledTableCell>{cal.solicitado}</StyledTableCell>
                                                <StyledTableCell><a href="./Informes-P">Realizar</a></StyledTableCell>
                                            </StyledTableRow>
                                        ))}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </Container>
                        :
                            null
                        }
                        {this.state.hayCarneSalud
                        ?
                            <Container>
                                <br/>
                                <h4>Carné de Salud Proximos a Vencer</h4>
                                <TableContainer style={{width: '80%', marginLeft:'auto', marginRight:'auto'}} component={Paper}>
                                    <Table sx={{minWidth: 700}}>
                                        <TableHead>
                                            <TableRow>
                                                <StyledTableCell width={'33%'}>Número Funcionario</StyledTableCell>
                                                <StyledTableCell width={'33%'}>Nombre Funcionario</StyledTableCell>
                                                <StyledTableCell width={'33%'}>Vencimiento</StyledTableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {this.state.carneSalud.map((car) => (
                                                <StyledTableRow key={car.numeroFuncionario}>
                                                    {car.vencido ? <StyledTableCell style={{color: 'red'}}>{car.numeroFuncionario}</StyledTableCell> : <StyledTableCell style={{color: 'blue'}}>{car.numeroFuncionario}</StyledTableCell>}
                                                    {car.vencido ? <StyledTableCell style={{color: 'red'}}>{car.nombreFuncionario}</StyledTableCell> : <StyledTableCell style={{color: 'blue'}}>{car.nombreFuncionario}</StyledTableCell>}
                                                    {car.vencido ? <StyledTableCell style={{color: 'red'}}>{car.fechaVencimiento}</StyledTableCell> : <StyledTableCell style={{color: 'blue'}}>{car.fechaVencimiento}</StyledTableCell>}
                                                </StyledTableRow>
                                            ))}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </Container>
                        :
                            null
                        }
                    </Container>
                :
                    <Redirect to='/login'/>
            }
            </>
        )
    }
}

export default ActividadesPendientes